import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
  {
    id: 1,
    title: 'Web Development',
    icon: '🌐',
    description: 'Modern, responsive web applications built with cutting-edge technologies. From UI/UX to backend systems, we create fast and scalable web solutions.',
    features: ['React / Vue / Angular', 'Node.js / Express', 'Full-Stack Development', 'Progressive Web Apps']
  },
  {
    id: 2,
    title: 'Android Development',
    icon: '📱',
    description: 'Native and cross-platform Android applications that deliver smooth performance and exceptional user experience.',
    features: ['Native Android', 'Kotlin / Java', 'Flutter', 'App Optimization']
  },
  {
    id: 3,
    title: 'Cloud Solutions',
    icon: '☁️',
    description: 'Scalable cloud infrastructure and migration services. Deploy, manage, and optimize your cloud environment with secure and efficient architectures.',
    features: ['AWS / Azure / GCP', 'Cloud Migration', 'DevOps & IaC', 'Containerization (Docker / Kubernetes)']
  },
  {
    id: 4,
    title: 'Data Analytics',
    icon: '📊',
    description: 'Transform raw data into actionable insights. We build dashboards, reports, and intelligent data models to help you make better decisions.',
    features: ['Data Visualization', 'ETL Pipelines', 'Big Data Processing', 'Business Intelligence']
  },
  {
    id: 5,
    title: 'AI & Machine Learning',
    icon: '🤖',
    description: 'Build intelligent systems that automate, predict, and enhance business processes using advanced AI and ML techniques.',
    features: ['Deep Learning', 'NLP', 'Computer Vision', 'Predictive Analytics']
  },
  {
    id: 6,
    title: 'Blockchain Solutions',
    icon: '⛓️',
    description: 'Secure and scalable decentralized solutions. Build next-generation blockchain applications, smart contracts, and digital asset platforms.',
    features: ['Smart Contracts', 'DApps', 'Ethereum / Solana', 'NFT Development']
  }
];


  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="section-header">
          <span className="section-tag">Our Services</span>
          <h2 className="section-title">
            Cutting-Edge <span className="highlight">Technology Solutions</span>
          </h2>
          <p className="section-description">
            We deliver innovative technology services that transform businesses 
            and drive digital excellence across all platforms.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="service-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <div className="service-hover-effect"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;


